import React, { useState } from 'react';
import './SmartwatchData.css';

function SmartwatchData() {
  const [selectedMetric, setSelectedMetric] = useState('heartRate');

  // Mock smartwatch data
  const metrics = {
    heartRate: {
      current: 72,
      unit: 'bpm',
      status: 'normal',
      icon: '❤️',
      label: 'Heart Rate',
      data: [68, 70, 72, 71, 73, 75, 72, 70, 69, 71, 74, 72]
    },
    steps: {
      current: 6842,
      unit: 'steps',
      goal: 10000,
      icon: '👟',
      label: 'Steps',
      data: [500, 1200, 1800, 2400, 3100, 3800, 4500, 5200, 5800, 6200, 6600, 6842]
    },
    sleep: {
      current: 6.5,
      unit: 'hours',
      status: 'below average',
      icon: '😴',
      label: 'Sleep',
      data: [7, 6.5, 7.5, 6, 6.5, 7, 6.5, 5.5, 6, 6.5, 7, 6.5]
    },
    stress: {
      current: 42,
      unit: '/100',
      status: 'moderate',
      icon: '😌',
      label: 'Stress Level',
      data: [35, 40, 38, 45, 50, 48, 42, 38, 40, 42, 44, 42]
    }
  };

  const dailyStats = [
    { time: '00:00', heartRate: 62, activity: 0 },
    { time: '04:00', heartRate: 58, activity: 0 },
    { time: '08:00', heartRate: 72, activity: 3 },
    { time: '12:00', heartRate: 78, activity: 5 },
    { time: '16:00', heartRate: 85, activity: 7 },
    { time: '20:00', heartRate: 70, activity: 2 },
  ];

  const recentAlerts = [
    { time: '2 hours ago', type: 'Elevated heart rate', value: '105 bpm', severity: 'warning' },
    { time: '5 hours ago', type: 'Low sleep quality', value: '3.2 hrs deep sleep', severity: 'info' },
    { time: 'Yesterday', type: 'High stress detected', value: '68/100', severity: 'warning' }
  ];

  const currentMetric = metrics[selectedMetric];

  return (
    <div className="smartwatch-data">
      <div className="smartwatch-header">
        <h2>Smartwatch Data</h2>
        <p>Real-time biomarkers from your wearable device</p>
        <div className="sync-status">
          <span className="sync-indicator active"></span>
          <span>Synced 5 min ago</span>
        </div>
      </div>

      {/* Metric Cards */}
      <div className="metrics-grid">
        {Object.entries(metrics).map(([key, metric]) => (
          <div
            key={key}
            className={`metric-card ${selectedMetric === key ? 'active' : ''}`}
            onClick={() => setSelectedMetric(key)}
          >
            <div className="metric-icon">{metric.icon}</div>
            <div className="metric-info">
              <span className="metric-label">{metric.label}</span>
              <span className="metric-value">
                {metric.current} {metric.unit}
              </span>
              {metric.status && (
                <span className={`metric-status ${metric.status.replace(' ', '-')}`}>
                  {metric.status}
                </span>
              )}
              {metric.goal && (
                <span className="metric-goal">
                  Goal: {metric.goal} {metric.unit}
                </span>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Detailed Chart */}
      <div className="chart-container">
        <h3>{currentMetric.label} - Last 12 Hours</h3>
        <div className="chart-area">
          <div className="chart-line">
            {currentMetric.data.map((value, index) => {
              const maxValue = Math.max(...currentMetric.data);
              const minValue = Math.min(...currentMetric.data);
              const range = maxValue - minValue || 1;
              const height = ((value - minValue) / range) * 100;
              
              return (
                <div key={index} className="chart-point-wrapper">
                  <div
                    className="chart-bar"
                    style={{ height: `${height}%` }}
                    title={`${value} ${currentMetric.unit}`}
                  ></div>
                  {index % 3 === 0 && (
                    <span className="chart-label">{index}h</span>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Daily Activity Timeline */}
      <div className="timeline-container">
        <h3>Today's Activity Timeline</h3>
        <div className="timeline">
          {dailyStats.map((stat, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-time">{stat.time}</div>
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-stat">
                  <span>❤️ {stat.heartRate} bpm</span>
                  <span>🏃 Activity: {stat.activity}/10</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Recent Alerts */}
      <div className="alerts-container">
        <h3>Recent Alerts</h3>
        <div className="alerts-list">
          {recentAlerts.map((alert, index) => (
            <div key={index} className={`alert-item ${alert.severity}`}>
              <div className="alert-icon">
                {alert.severity === 'warning' ? '⚠️' : 'ℹ️'}
              </div>
              <div className="alert-content">
                <div className="alert-type">{alert.type}</div>
                <div className="alert-value">{alert.value}</div>
                <div className="alert-time">{alert.time}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Connection Status */}
      <div className="connection-status">
        <div className="status-card">
          <h4>Device Connection</h4>
          <div className="device-info">
            <span className="device-name">Apple Watch Series 8</span>
            <span className="battery-level">🔋 85%</span>
          </div>
          <button className="sync-btn">Sync Now</button>
        </div>
      </div>
    </div>
  );
}

export default SmartwatchData;

















